import { useBoolean } from 'minimal-shared/hooks'

import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Avatar from '@mui/material/Avatar'
import Drawer from '@mui/material/Drawer'
// import { Stack } from '@mui/material'
// import Tooltip from '@mui/material/Tooltip'
import MenuList from '@mui/material/MenuList'
import MenuItem from '@mui/material/MenuItem'
import IconButton from '@mui/material/IconButton'
import { faClose } from '@fortawesome/pro-duotone-svg-icons'

import { Scrollbar } from 'src/components/scrollbar'
import { AnimateBorder } from 'src/components/animate'

import { AccountButton } from './account-button'
import FaIcon from '../../components/shared/faIcon/FaIcon'
import Button from '../../components/shared/button/Button'
import { RouterLink } from '../../routes/components'
import { NAVIGATION_BLANK_PARAMS } from '../../util/navigation.helpers'
import Text from '../../components/text/Text'
// import { Label } from '../../components/label'

export function AccountDrawer({
  data = [],
  sx,
  t,
  userInitials,
  firstName,
  lastName,
  email,
  // membershipStatus = 'MEM_STATUS',
  // membershipName = 'MEM_NAME',
  signOut,
  ...other
}) {
  const { value: open, onFalse: onClose, onTrue: onOpen } = useBoolean()

  const handleSignOut = () => {
    signOut()
    onClose()
  }

  const renderAvatar = () => (
    <AnimateBorder
      sx={{ mb: 2, p: '6px', width: 96, height: 96, borderRadius: '50%' }}
      slotProps={{
        primaryBorder: { size: 120, sx: { color: 'primary.main' } }
      }}
    >
      <Avatar
        alt={userInitials}
        sx={{ width: 1, height: 1, fontSize: 32, color: 'primary.main' }}
      >
        {userInitials}
      </Avatar>
    </AnimateBorder>
  )

  const renderList = () => (
    <MenuList
      disablePadding
      sx={[
        (theme) => ({
          py: 3,
          px: 2.5,
          borderTop: `dashed 1px ${theme.vars.palette.divider}`,
          borderBottom: `dashed 1px ${theme.vars.palette.divider}`,
          '& li': { p: 0 }
        })
      ]}
    >
      {data.map(({ path, icon, title, external }) => {
        const linkProps = external
          ? { href: path, ...NAVIGATION_BLANK_PARAMS }
          : { component: RouterLink, to: path }

        return (
          <MenuItem key={title}>
            <Link
              {...linkProps}
              color='inherit'
              underline='none'
              onClick={onClose}
              sx={{
                p: 1,
                width: 1,
                display: 'flex',
                typography: 'body2',
                alignItems: 'center',
                color: 'text.secondary',
                '&:hover': { color: 'text.primary' }
              }}
            >
              <FaIcon icon={icon} />
              <Box component='span' sx={{ ml: 1.4 }}>
                {title}
              </Box>
            </Link>
          </MenuItem>
        )
      })}
    </MenuList>
  )

  return (
    <>
      <AccountButton
        onClick={onOpen}
        userInitials={userInitials}
        sx={sx}
        {...other}
      />

      <Drawer
        open={open}
        onClose={onClose}
        anchor='right'
        slotProps={{ backdrop: { invisible: true } }}
        PaperProps={{ sx: { width: 320 } }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            top: 12,
            left: 12,
            zIndex: 9,
            position: 'absolute',
            width: 36,
            height: 36
          }}
        >
          <FaIcon icon={faClose} size='sm' />
        </IconButton>

        <Scrollbar>
          <Box
            sx={{
              pt: 8,
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column'
            }}
          >
            {renderAvatar()}

            <Text
              variant='subtitle1'
              color=''
              noWrap
              sx={{ mt: 2 }}
              label={`${firstName} ${lastName}`}
            />
            <Text
              variant='body2'
              sx={{ color: 'text.secondary', mt: 0.5, mb: 3 }}
              noWrap
              label={email}
            />
          </Box>

          {/* <Stack spacing={2} alignItems='center'>
            <Tooltip title={membershipStatus}>
              <Avatar
                alt={membershipStatus}
                src={'https://qbxfdnkeytest.qiibeefoundation.org/favicon.png'}
              />
            </Tooltip>
            <Label color='primary'>{membershipName}</Label>
          </Stack> */}
          {renderList()}
        </Scrollbar>

        <Box sx={{ p: 2.5 }}>
          <Button
            fullWidth
            variant='soft'
            size='large'
            color='error'
            onClick={handleSignOut}
            label={t('nav-header.log-out')}
          />
        </Box>
      </Drawer>
    </>
  )
}
